import React from 'react';
import { Container, Button, Icon, Label } from './Pagination.styles';
import Skeleton from '../Skeleton/Skeleton';

export interface PaginationProps {
  pages: number;
  currentPage: number;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  pages,
  loading,
  onPageChange,
}: PaginationProps) {
  if (pages === 0) {
    return <></>
  }

  if (pages < 1) {
    currentPage = 0;
    pages = 0;
  }

  return (
    <Container aria-label="Pagination">
      <Button
        disabled={currentPage <= 1}
        onClick={() => onPageChange(1)}
        aria-label="First page"
      >
        <Icon $left icon={'other.arrowRightLine'} disabled={currentPage <= 1} />
      </Button>
      <Button
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        <Icon $left icon={'other.arrowRight'} disabled={currentPage <= 1} />
      </Button>
      {loading ? (
        <Skeleton width={70} />
      ) : (
        <Label aria-label="Current page">
          Page {currentPage} of {pages}
        </Label>
      )}
      <Button
        disabled={currentPage >= pages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        <Icon icon={'other.arrowRight'} disabled={currentPage >= pages} />
      </Button>
      <Button
        disabled={currentPage >= pages}
        onClick={() => onPageChange(pages)}
        aria-label="Last page"
      >
        <Icon icon={'other.arrowRightLine'} disabled={currentPage >= pages} />
      </Button>
    </Container>
  );
}
